// let cookies
//
const { isElectron } = require('@/utils/common')
const isE = isElectron()
let store
if(isE) {
    const Store = require('electron-store')
    store = new Store()
}


// const { session } = require('electron')
const TokenKey = 'SCHOOL'
// const session = require('electron').remote.session
// const cookies = session.defaultSession.cookies
// let token = null
//
// async function test() {
//     token = await cookies.get({url: 'http://edu.kjt61.com', name: TokenKey}).then((cookies) => {
//         token = cookies
//     }).catch((error) => {
//         console.error(error)
//     })
// }
// test()
//获取token
export function getToken(key=TokenKey) {
    let token
    if(isE) {
        token = store.get(key)
    }else{
        token = localStorage.getItem(key)
    }
    return token
}

//设置token
export function setToken(token, key=TokenKey) {
    if(isE) {
        store.set(key,token)
    }else{
        localStorage.setItem(key, token)
    }

}

//清除token
export function removeToken(key=TokenKey) {
    if(isE) {
        store.delete(key)
    }else{
        localStorage.removeItem(key)
    }
}
